<template>
  <div>
    <b-form @submit.prevent="onSubmit" class="mt-3">
      <b-row>
        <b-col xl="8" lg="7" md="6">
          <h2>Flagship Hit Validator</h2>
        </b-col>
        <b-col>
          <b-row
            class="mt-1"
            style="align-items:center;justify-content:flex-end"
          >
            <b-col sm="3">
              <label
                style="margin-bottom:0;"
                for="inline-form-custom-select-pref"
                >Hit type</label
              >
            </b-col>
            <b-col>
              <b-form-select
                id="input-3"
                v-model="form.type"
                :options="types"
                @change="reset()"
                required
              ></b-form-select>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <v-jsoneditor
        class="mt-3 mb-2"
        v-model="form.body"
        :options="options"
        :plus="false"
        height="400px"
        @change="reset()"
        @error="onJsonError"
      />
      <div style="max-width:300px;margin:auto">
        <b-button
          size="lg"
          block
          class="my-3 fs-button"
          type="submit"
          variant="primary"
          >Validate event</b-button
        >
      </div>
      <b-alert show variant="success" v-if="this.validationErrors === false"
        >
        <span class="fs-hit-label">{{this.form.type}}</span> hit is correct
      </b-alert>
      <b-alert
        show
        variant="danger"
        v-if="this.validationErrors && this.validationErrors.length > 0"
      >
        <ul class="list">
          <li v-for="e in validationErrors" :key="e">{{ e }}</li>
        </ul>
      </b-alert>
      <b-alert show variant="danger" v-if="this.validationHttpError">{{
        this.validationHttpError
      }}</b-alert>
    </b-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "JsonEditor",
  data() {
    return {
      options: {
        mode: "code"
      },
      form: {
        type: "SCREENVIEW",
        body: {}
      },
      types: ["SCREENVIEW", "EVENT", "TRANSACTION", "ITEM"],
      jsonError: null,
      validationErrors: null,
      validationHttpError: false
    };
  },
  methods: {
    reset() {
      this.validationHttpError = false;
      this.validationErrors = null;
    },
    onSubmit() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL ||
            ""}/send/${this.form.type.toLowerCase()}`,
          this.form.body
        )
        .then(res => {
          if (res.status === 200) {
            this.validationErrors = false;
          }
        })
        .catch(e => {
          if (e.response.status === 400) {
            this.validationErrors = e.response.data.errors;
          } else {
            this.validationHttpError = e;
          }
        });
    },

    onJsonError(e) {
      this.jsonError = e;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list {
  margin-bottom: 0;
}

.fs-button:hover {
  background-color: rgb(155, 46, 77);
  background-image: linear-gradient(to right, #d01c6c, #ff6842);
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}

.fs-hit-label {
  text-transform:lowercase;
}

.fs-button {
  color: #fff;
  background-color: #de436f;
  background-image: linear-gradient(to right, #d23078, #ff7856);
  border: none;
  font-family: "Work Sans";
  font-weight: 500;
  line-height: 1.75;
  border-radius: 4px;
  text-transform: uppercase;
}

.btn.fs-button:focus,
.btn.fs-button:active {
  color: #fff;
  background-color: transparent;
  border-color: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>

<style>
body {
  background-color: #343434 !important;
}
h2,
label {
  color: #fff;
}
.jsoneditor-menu {
  color: #fff;
  background-color: #272727;
  border-bottom: 1px solid #343434;
}
.jsoneditor {
  border: 1px solid #272727;
}
/* .jsoneditor-outer.has-main-menu-bar {
  background-color: #272727;
}
.jsoneditor .ace_gutter {
  background: #2f3129;
  color: #8f908a;
} */
</style>
